<script lang="ts">
  import { onMount } from "svelte";
  import Input from "../../components/Form/Fields/Input.svelte";
  import NumberInput from "../../components/Form/Fields/NumberInput.svelte";
  import FormField from "../../components/Form/FormField.svelte";
  import FormLayout from "../../layout/FormLayout.svelte";
  import { init, record, save } from "./settings-general.store";
  import Switch from "../../components/Form/Fields/Switch.svelte";

  /*
  $: canSubmit =
    $record != null &&
    $record.expirationWarningDays >= 0 &&
    !!$record.companyName;
  */
  $: canSubmit = $record != null;

  async function onSubmit() {
    await save();
  }

  onMount(init);
</script>

{#if $record != null}
  <div class="columns">
    <div class="column is-12">
      <FormLayout on:submit={onSubmit} cancelEnabled={false} {canSubmit}>
        <div class="columns">
          <div class="column is-6">
            <FormField>
              <Input name="Denominazione Azienda" placeholder="" required={true} maxlength={200} bind:value={$record.companyName} />
            </FormField>
          </div>
          <div class="column is-6">
            <FormField>
              <Input name="Bollo CEE" placeholder="" required={true} maxlength={20} bind:value={$record.eecStampNumber} />
            </FormField>
          </div>
        </div>

        <div class="columns">
          <div class="column is-6">
            <FormField>
              <Input name="Nazione allevamento" placeholder="" required={true} maxlength={40} bind:value={$record.productRaisedCountry} />
            </FormField>
          </div>
          <div class="column is-6">
            <FormField>
              <Input name="Nazione macellazione" placeholder="" required={true} maxlength={40} bind:value={$record.productSlaughteredCountry} />
            </FormField>
          </div>
        </div>

        <div class="columns">
          <div class="column is-2">
            <FormField>
              <Switch name="Stampa etichette" bind:value={$record.labelPrintEnabled} />
            </FormField>
          </div>
          <div class="column is-4">
            <FormField>
              <NumberInput name="Ritardo stampa etichette (secondi)" placeholder="" required={true} bind:value={$record.labelPrintDelaySeconds} />
            </FormField>
          </div>
          <div class="column is-6">
            <FormField>
              <Switch name="Lettura peso automatica" bind:value={$record.waitForWeight} />
            </FormField>
          </div>
        </div>
      </FormLayout>
    </div>
  </div>
{/if}
